<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Nom du magasin / Client :</label>
            <input
              class="form-control"
              type="text"
              id="customer"
              v-model="customer"
            />
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label>Votre Code :</label>
            <input
              class="form-control"
              type="text"
              id="code"
              v-model="custcode"
            />
          </div>
        </div>

        <div class="col-md-4">
          <b-button
            style="margin-top: 22px"
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            @click="filter()"
          >
            <i class="flaticon-search"></i>
            Chercher
            <!-- <template v-if="isLoader">
                <b-spinner small />
              </template> -->
          </b-button>
          <b-button
            style="margin-top: 22px"
            variant="danger"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            @click="removefilter()"
          >
            <i class="flaticon-close"></i>
            Annuler
          </b-button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing mb-20"
    v-if="showData"
  >
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <label>Voir</label>
        <v-select
          v-model="filters.per_page"
          :options="[10, 25, 50]"
          :clearable="false"
          class="per-page-selector d-inline-block mx-50"
          @input="getRecords()"
        />
        <label>sur {{ filters.total }} entités</label>
      </div>
      <div class="d-sm-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
          @change="filter()"
          @input="handleInput"
          v-model="filters.searchTerm"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="columns" :rows="rows" :loading="isLoader">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
              <b>{{ props.row.note_ref }}</b>
            </span>
            <template v-else-if="props.column.field === 'note_customer_name'">
              <div class="text-nowrap">
                <b>{{ props.row.magasin_name }}</b
                ><br />
                ({{ props.row.note_customer_name }})
              </div>
            </template>

            <span
              v-else-if="props.column.field === 'created_at'"
              class="text-nowrap"
            >
              <h5 v-if="props.row.created_at != null">
                {{ getDate(props.row.created_at) }}
              </h5>
            </span>

            <span
              v-else-if="props.column.field === 'note_total_parcel'"
              class="text-nowrap"
            >
              <h5>{{ props.row.note_total_parcel }}</h5>
            </span>
            <span
              v-else-if="props.column.field === 'note_total_crbt'"
              class="text-nowrap"
            >
              <h5>{{ props.row.crbt }} DH</h5>
            </span>

            <template v-else-if="props.column.field === 'note_saved'">
              <span
                v-if="props.row.note_saved == 0"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.note_saved
                )}`"
                class="text-capitalize"
              >
                Nouveau
              </span>
              <span
                v-else
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.note_saved
                )}`"
                class="text-capitalize"
              >
                Enregistré
              </span>
            </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="auth.can('BL_EXT')">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showDetailSuivi(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </a>
                </li>
                <li v-if="auth.can('BL_EXT') && props.row.note_total_parcel == 0">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="removeBL(props.row.id)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
                <li>
                  <a
                    v-if="auth.can('BL_EXT') && props.row.note_total_parcel != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>

                <li>
                  <a
                    v-if="auth.can('BL_EXT') && props.row.note_total_parcel != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="ticketsPDF(props.row)"
                  >
                    <i
                      class="flaticon-menu lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>

                <li>
                  <a
                    v-if="auth.can('BL_EXT') && props.row.note_total_parcel != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="tickets4PDF(props.row)"
                  >
                    <i
                      class="flaticon-more-1 lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>

  <div class="modal fade" id="detailBonModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Informations colis</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <details-note
            :noteBL="noteBL"
            :getRecords="getRecords"
            :type="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";
import DetailsNote from "../Delivery/DetailsNote.vue";
import { Modal } from "bootstrap";

export default {
  name: "ListeNotes",
  components: { DetailsNote },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const noteBL = ref(null);

    const showData = ref(false);

    const customer = ref(null);
    const custcode = ref(null);
    const columns = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Store",
        field: "note_customer_name",
      },
      {
        label: "Date de création",
        field: "created_at",
        width: "180px",
      },
      {
        label: "Statut",
        field: "note_saved",
      },
      {
        label: "Colis",
        field: "note_total_parcel",
      },
      {
        label: "Total",
        field: "crbt",
      },
      {
        label: "Action",
        field: "action",
      },
    ];
    const filters = reactive({
      searchCode: "",
      searchCustomer: "",
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(() => {
      // getRecords();
    });
    async function getRecords(page = 1) {
      filters.current_page = page;
      if (!custcode.value || !customer.value) {
        showToast("Veuillez sélectionner un client et un code de livraison.", "warning");
        return;
      }
      try {
        isLoader.value = true;
        const response = await api.get(
          `/api/auth/delivery_extern?searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`,
          {
            params: {
              searchCode: custcode.value,
              searchCustomer: customer.value,
            },
          }
        );

        // rows.value = response.data.users.data;
        // Object.assign(filters, response.data.users);
        if (response.data.msg == "success") {
          rows.value = response.data.users.data;
          Object.assign(filters, response.data.users);
          showData.value = true;
        } else if (response.data.msg == "no customer found") {
          showToast("Client introuvable", "error");
        } else {
          showToast(
            "un problème est survenu merci de réessayer encore !!",
            "error"
          );
        }
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    function filter() {
      //   filters.searchCustomer = this.customer_filter.id
      //   filters.searchStatut = this.status_filter
      //   filters.searchStore = this.store_filter.id
      //   filters.searchSDate = (this.$refs.myInput.dateRange.start == undefined || this.$refs.myInput.dateRange.start == 'undefined') ? '' : this.convert(this.$refs.myInput.dateRange.start)
      //   filters.searchEDate = (this.$refs.myInput.dateRange.end == undefined || this.$refs.myInput.dateRange.end == 'undefined') ? '' : this.convert(this.$refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function removeFilter() {
      // filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      // filters.searchSDate = filters.searchEDate = filters.searchDateType = "";
      //   this.customer_filter = this.store_filter = { id: '', name: '' }
      //   this.date_filter = this.status_filter = this.type_date_filter = ''
      //   this.$refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }
    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(this.debounceTimer);

      //   // Set a new debounce timer
      //   this.debounceTimer = setTimeout(() => {
      //     if (!this.searchTerm || this.searchTerm === '') {
      //     filters.searchTerm = this.searchTerm
      //     this.filter()
      //   } else if (this.searchTerm && this.searchTerm.length > 4) {
      //     filters.searchTerm = this.searchTerm
      //     this.filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function removeBL(id) {
      const data = new FormData();
      data.append("bl_id", id);

      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon de livraison ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/DeleteBL`, data);

          if (res.data.message === "success") {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Le bon de livraison est bien supprimé",
              showConfirmButton: false,
              timer: 1500,
            });

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `this.getRecords()`.
          } else if (res.data.message === "Issaved") {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Vous pouvez pas le supprimer!",
            });
          }
        } catch (error) {
          console.error("Erreur suppression BL:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong! Veuillez réessayer",
          });
        }
      }
    }

    async function saveBL(id) {
      try {
        const res = await api.post(`/api/auth/SaveBL/${id}`);

        if (res.data.message === "success") {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Le bon de livraison est bien enregistré",
            showConfirmButton: false,
            timer: 1500,
          });

          getRecords(); // 🔹 if Composition API. Use `this.getRecords()` if Options API.
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Erreur, merci de réessayer encore!",
          });
        }
      } catch (error) {
        console.error("Erreur API SaveBL:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong! Veuillez réessayer",
        });
      }
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/DELPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    async function ticketsPDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketsPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération TicketsPDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF des tickets",
        });
      }
    }

    async function tickets4PDF(row) {
      try {
        const response = await api.get(`/api/auth/Tickets4PDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération Tickets4PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF (4 tickets)",
        });
      }
    }
    function showDetailSuivi(row) {
      noteBL.value = {};
      // noteBmBL=[];
      noteBL.value = row;

      const modalEl = document.getElementById("detailBonModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      filter,
      convert,
      removeFilter,
      handleInput,

      showDetailSuivi,
      removeBL,
      saveBL,
      getPDF,
      ticketsPDF,
      tickets4PDF,
      noteBL,

      showData,
      customer,
      custcode,
    };
  },
};
</script>